<template>
  <b-container>
    <b-row>
      <b-col>
        <b-form-group
          id="language"
          label="Language:"
          label-for="language-input"
        >
          <b-row>
            <b-col class="d-flex">
              <b-col class="col-11 pr-1 pl-0">
                <!-- <b-form-select v-model="language"
                               :options="optionsLanguages">
                </b-form-select> -->
                <vue-bootstrap-typeahead
                  id="language"
                  v-model="language"
                  no-resize
                  :data="$typeAheadAboutsLanguage"
                  placeholder="Language here..."
                  ref="language"
                  :serializer="s => `${s.text}`"
                  @hit="$event => (language = $event.text)"
                />
              </b-col>
              <b-col
                class="col-1 pl-0 pr-0"
                v-if="
                  (profile.abouts &&
                    language !== profile.abouts.language &&
                    language) ||
                    (!profile.abouts && language) ||
                    (!profile.abouts.language && language)
                "
              >
                <b-button
                  class="fas fa-save"
                  variant="primary"
                  @click="saveChangeData('language')"
                ></b-button>
              </b-col>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group
          id="timezone"
          label="Timezone:"
          label-for="timezone-input"
        >
          <b-row>
            <b-col class="d-flex">
              <b-col class="col-11 pr-1 pl-0">
                <!-- <b-form-select v-model="timezone"
                               :options="optionsTimezones">
                </b-form-select> -->
                <vue-bootstrap-typeahead
                  id="timezone"
                  v-model="timezone"
                  no-resize
                  :data="$typeAheadAboutsTimezone"
                  placeholder="Timezone here..."
                  ref="timezone"
                  :serializer="s => `${s.text}`"
                  @hit="$event => (timezone = $event.text)"
                />
              </b-col>
              <b-col
                class="col-1 pl-0 pr-0"
                v-if="
                  (profile.abouts &&
                    timezone !== profile.abouts.timezone &&
                    timezone) ||
                    (!profile.abouts && timezone) ||
                    (!profile.abouts.timezone && timezone)
                "
              >
                <b-button
                  class="fas fa-save"
                  variant="primary"
                  @click="saveChangeData('timezone')"
                ></b-button>
              </b-col>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group
          id="spiritual"
          label="Spiritual:"
          label-for="spiritual-input"
        >
          <b-row>
            <b-col class="d-flex">
              <b-col class="col-11 pr-1 pl-0">
                <!-- <b-form-select v-model="spiritual"
                               :options="optionsSpiritual">
                </b-form-select> -->
                <vue-bootstrap-typeahead
                  id="spiritual"
                  v-model="spiritual"
                  no-resize
                  :data="$typeAheadAboutsSpiritual"
                  placeholder="Spiritual here..."
                  ref="spiritual"
                  :serializer="s => `${s.text}`"
                  @hit="$event => (spiritual = $event.text)"
                />
              </b-col>
              <b-col
                class="col-1 pl-0 pr-0"
                v-if="
                  (profile.abouts &&
                    spiritual !== profile.abouts.spiritual &&
                    spiritual) ||
                    (!profile.abouts && spiritual) ||
                    (!profile.abouts.spiritual && spiritual)
                "
              >
                <b-button
                  class="fas fa-save"
                  variant="primary"
                  @click="saveChangeData('spiritual')"
                ></b-button>
              </b-col>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group
          id="political"
          label="Political:"
          label-for="political-input"
        >
          <b-row>
            <b-col class="d-flex">
              <b-col class="col-11 pr-1 pl-0">
                <!-- <b-form-select v-model="political"
                               :options="optionsPolitical">
                </b-form-select> -->
                <vue-bootstrap-typeahead
                  id="political"
                  v-model="political"
                  no-resize
                  :data="$typeAheadAboutsPolitical"
                  placeholder="Political here..."
                  ref="political"
                  :serializer="s => `${s.text}`"
                  @hit="$event => (political = $event.text)"
                />
              </b-col>
              <b-col
                class="col-1 pl-0 pr-0"
                v-if="
                  (profile.abouts &&
                    political !== profile.abouts.political &&
                    political) ||
                    (!profile.abouts && political) ||
                    (!profile.abouts.political && political)
                "
              >
                <b-button
                  class="fas fa-save"
                  variant="primary"
                  @click="saveChangeData('political')"
                ></b-button>
              </b-col>
            </b-col>
          </b-row>
        </b-form-group>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
// import firebase from "firebase";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";

export default {
  components: {
    VueBootstrapTypeahead
  },
  props: {
    profile: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    toggleShow() {
      this.show = !this.show;
    },
    handleParentSave() {
      // // debugger;
    },
    handleParentReset() {
      // // debugger;
    },
    handleSubmitClick() {
      this.isEditingAbout = !this.isEditingAbout;
    },
    handleUpdateClick() {
      let profile = {};
      //TODO: Add Validation of Data
      //TODO: Add Ability to update Email
      //TODO: Add Ability to add and update skills
      this.$store
        .dispatch("user/updateProfile", profile)
        .then(() => {
          this.$nprogress.done();
        })
        .catch(error => {
          this.$nprogress.done();
          this.$store.dispatch("user/showNotification", {
            title: error.code,
            description: error.message,
            variant: "danger"
          });
        });
    },
    saveChangeData(type) {
      let dataToUpdate = {
        abouts: { ...this.profile.abouts, [type]: this[type] }
      };
      this.$store.dispatch("user/updateProfile", dataToUpdate).then(res => {
        if (res) {
          this.$store.dispatch("user/getProfile").then(() => {
            console.log(`change about: ${type} success to about ${this[type]}`);
          });
        }
      });
    }
  },
  computed: {
    hasUpdates() {
      return true;
    }
  },
  mounted() {
    setTimeout(() => {
      if (
        this.profile &&
        this.profile.abouts &&
        this.profile.abouts.language &&
        this.$refs.language
      )
        this.$refs.language.$data.inputValue = this.profile.abouts.language;
      if (
        this.profile &&
        this.profile.abouts &&
        this.profile.abouts.timezone &&
        this.$refs.timezone
      )
        this.$refs.timezone.$data.inputValue = this.profile.abouts.timezone;
      if (
        this.profile &&
        this.profile.abouts &&
        this.profile.abouts.spiritual &&
        this.$refs.spiritual
      )
        this.$refs.spiritual.$data.inputValue = this.profile.abouts.spiritual;
      if (
        this.profile &&
        this.profile.abouts &&
        this.profile.abouts.political &&
        this.$refs.political
      )
        this.$refs.political.$data.inputValue = this.profile.abouts.political;
    }, 100);
  },
  data: function() {
    return {
      form: this.$form.createForm(this),
      show: false,
      params: {
        token: "123456798",
        name: "avatar"
      },
      headers: {
        smail: "*_~"
      },
      imgDataUrl: "", // the datebase64 url of created image
      language:
        this.profile && this.profile.abouts && this.profile.abouts.language
          ? this.profile.abouts.language
          : "",
      timezone:
        this.profile && this.profile.abouts && this.profile.abouts.timezone
          ? this.profile.abouts.timezone
          : "",
      spiritual:
        this.profile && this.profile.abouts && this.profile.abouts.spiritual
          ? this.profile.abouts.spiritual
          : "",
      political:
        this.profile && this.profile.abouts && this.profile.abouts.political
          ? this.profile.abouts.political
          : ""

      //MOVED TO MIXINS
      // optionsLanguages: [
      //   { value: null, text: 'Please select your Language' },
      //   { value: 'English (USA)', text: 'English (USA)' }
      // ],
      // optionsTimezones: [
      //   { value: null, text: 'Please select your TimeZone' },
      //   { value: 'PST', text: 'PST' }
      // ],
      // optionsSpiritual: [
      //   { value: null, text: 'optional' },
      //   { value: 'Baptist', text: 'Baptist (USA)' }
      // ],
      // optionsPolitical: [
      //   { value: null, text: 'optional' },
      //   { value: 'Democrat', text: 'Democrat' }
      // ]
    };
  }
};
</script>
